import { configOption, KahunConfigurationOptionType } from "../lib/annotations";
import { MessageTemplate } from "./messageTemplate";

export enum EmailProviders {
  emailJs = "email-js",
}

export class EmailOptions {
  @configOption({
    description: "Is this option enabled from the ui",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  enabled: boolean = true;

  @configOption({
    description:
      "Which email client we use, currently only EmailJS is supported",
    options: EmailProviders,
    displayType: KahunConfigurationOptionType.Choice,
  })
  provider: EmailProviders = EmailProviders.emailJs; // Currently we only support EmailJs, theoretically can be mailchimp etc
  @configOption({
    description:
      "What id to use as emailing service. in email js each gmail account linked gets its won service id",
    displayType: KahunConfigurationOptionType.String,
  })
  serviceId: string;
  @configOption({
    description: "User public key",
    displayType: KahunConfigurationOptionType.String,
  })
  userId: string;
  @configOption({
    description: "List of templated per-touch point",
    displayType: KahunConfigurationOptionType.MessageTemplate,
  })
  emailTemplates: MessageTemplate[];
  @configOption({
    description: "Sometimes called private key",
    displayType: KahunConfigurationOptionType.String,
  })
  accessToken: string;
}
